<section>
  <h3>Mi cuenta</h3>
  <h2>Hola {{ username }}</h2>

  <form class="card" autocomplete="off" [formGroup]="form">
    <div class="title-actions">
      <h4 class="title">
        <span class="icon-Password"></span>
        Cambiar la contraseña
      </h4>
    </div>
    <div class="ggi-input password-input">
      <input
        ggiJourneyControlValidator
        formControlName="actualPassword"
        [type]="actualText ? 'text' : 'password'"
        id="actualPassword"
      />
      <label for="actualPassword"> Contraseña anterior </label>
      <button type="button" tabindex="-1" (click)="changeInputType('actual')">
        <span class="icon-Eye-Opened" *ngIf="actualText"></span>
        <span class="icon-Eye-Closed" *ngIf="!actualText"></span>
      </button>
    </div>

    <div class="ggi-input password-input">
      <input
        ggiJourneyControlValidator
        formControlName="newPassword"
        [type]="newText ? 'text' : 'password'"
        id="newPassword"
      />
      <label for="newPassword"> Nueva contraseña </label>
      <button type="button" tabindex="-1" (click)="changeInputType('new')">
        <span class="icon-Eye-Opened" *ngIf="newText"></span>
        <span class="icon-Eye-Closed" *ngIf="!newText"></span>
      </button>
      <p
        class="text-small error"
        *ngIf="
          form.get('newPassword').value === form.get('actualPassword').value &&
          form.get('newPassword').touched
        "
      >
        La nueva contraseña no puede ser igual a la contraseña anterior
      </p>
    </div>

    <div class="ggi-input password-input">
      <input
        ggiJourneyControlValidator
        formControlName="confirmPassword"
        [type]="confirmText ? 'text' : 'password'"
        id="confirmPassword"
      />
      <label for="confirmPassword"> Confirmar nueva contraseña </label>
      <button type="button" tabindex="-1" (click)="changeInputType('confirm')">
        <span class="icon-Eye-Opened" *ngIf="confirmText"></span>
        <span class="icon-Eye-Closed" *ngIf="!confirmText"></span>
      </button>
      <p
        class="text-small error"
        *ngIf="
          form.get('newPassword').value !== form.get('confirmPassword').value &&
          form.get('confirmPassword').touched
        "
      >
        Las contraseñas no son iguales
      </p>
    </div>
    <div class="action-buttons">
      <button type="button" class="btn-filled" (click)="submitChangePassword()">
        Guardar
      </button>
      <button type="button" class="btn-without-filled" (click)="cancel()">
        Cancelar
      </button>
    </div>
  </form>
</section>

<ggi-journey-modal-cancel
  *ngIf="showCancel"
  [title]="'modificación de tu contraseña'"
  (closeModal)="back()"
  (backForm)="showCancel = false"
>
</ggi-journey-modal-cancel>
